/**
 * @file pluginloader.class.js
 * @description Defines the PluginLoader class.
 */

class PluginLoader {
  constructor(debug = false) {
    this.init();
    this.debug();
  }
  
  init() {
    this.initLazyload();
  }

  /**
   * @description Initializes the lazyload plugin
   * @link https://github.com/devtritoncommerce/lazyload
   */
  initLazyload() {
    this.lazyload = new LazyLoad({
      elements_selector: ".lazyload",
      threshold: 0,
      rootMargin: '0px 0px -20% 0px', 
      onEnter: (element) => {
        element.classList.add('loaded');
    },
    });
  }

  /**
   * @description Initializes the accordion plugin
   * @link
   */
  static initAccordion() {
    let elements = document.querySelectorAll('[data-accordion-group]');
    window.triton.cleanAccordion = new CleanAccordion(elements);
  }

  /**
   * @description Initializes the progress bar plugin
   * @link
   */
  static initProgressBar() {
    let elements = document.querySelectorAll('.progress-bar');
    window.triton.progressBarWrapper = new ProgressBarWrapper(elements);
  }

  /**
   * @description Initializes the tabs plugin
   * @link null
   */
  static initTabs() {
    let elements = document.querySelectorAll('[data-tab-group]');
    window.triton.cleanTabs = new CleanTabs(elements);
  }

  /**
   * @description Initializes the slider plugin
   * @link null
   * TODO: Replace this with plugin written in vanilla JS.
   */
  static initSlider() {

    window.triton.flickity = [];
    const elements = document.querySelectorAll('.flickity');

    elements.forEach( flickity => {
      window.triton.flickity.push(new Flickity(flickity, {
        cellAlign: 'left',
        wrapAround: true,
        groupCells: true,
      }));
    });
  }

  /**
   * @description Initializes the read-more instance of CleanAccordion
   */
  static initReadMore() {

    let readMoreElements = document.querySelectorAll('.read-more');
    window.triton.readMore = new CleanAccordion(readMoreElements, {
      afterOpen: function(accordion) {
        let control = accordion.querySelector('[data-control]:last-of-type');
        if (!control) return;
        let controlText = 'Read Less';

        if (control.hasAttribute('data-less')) {
          controlText = control.dataset.less;
        }

        control.innerText = controlText;
        control.title = controlText;
      },
      afterClose: function(accordion) {
        let control = accordion.querySelector('[data-control]:last-of-type');
        if (!control) return;
        let controlText = 'Read More';

        if (control.hasAttribute('data-more')) {
          controlText = control.dataset.more;
        }

        control.innerText = controlText;
        control.title = controlText;
      }
    });

  }

  /**
   * @description Initializes the lightbox plugin
   * All fslightbox instances are instantiated by default. However, when an ID is used as the
   * href target we need to make sure it's hidden from the user until the modal is opened.
   */
  static initLightbox() {

    let elements = document.querySelectorAll('[data-fslightbox]');
    elements.forEach( (element) => {

      // 1. Check if hash is an element ID.
      let hash = element.hash;
      if (hash.length > 1 && hash.indexOf('#') === 0) {
        
        // 2. Hide the targeted element. This should only show when the lightbox is opened.
        let ligthboxTarget = document.querySelector(hash);
        ligthboxTarget.style.display = 'none';

      }

    });
  }

  debug() {
    if (debug) {
      console.groupCollapsed('%c PluginLoader', 'color: #bada55');
      console.log(this);
      console.groupEnd();
    } 
  }
}